"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importStar(require("react"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const react_redux_1 = require("react-redux");
const recompose_1 = require("recompose");
const reselect_1 = require("reselect");
const selectors_1 = require("@zedoc/selectors");
const QuestionnaireContext_1 = require("./QuestionnaireContext");
const SelectorsHub_1 = __importDefault(require("./SelectorsHub"));
const getValue_1 = __importDefault(require("./getValue"));
const propTypes_1 = require("./propTypes");
const isReactNative_1 = __importDefault(require("./isReactNative"));
class Field extends react_1.default.Component {
    static getDerivedStateFromProps(props, state) {
        if (state.pending) {
            if (state.value !== props.value) {
                return null;
            }
            return {
                pending: false,
            };
        }
        return {
            value: props.value,
        };
    }
    // TODO: Implement optional debounce, e.g. handle state locally, and sync to store after some delay.
    constructor(props) {
        super(props);
        this.state = {};
        this.handleOnChange = this.handleOnChange.bind(this);
        this.getInput = (0, reselect_1.createStructuredSelector)({
            value: (0, selectors_1.argument)(0, 'value'), // state.value
            onChange: (0, selectors_1.constant)(this.handleOnChange),
        });
        this.getMeta = (0, reselect_1.createStructuredSelector)({
            error: (0, reselect_1.createSelector)((0, selectors_1.property)('context'), (0, selectors_1.property)('name'), (0, selectors_1.property)('value'), (0, selectors_1.property)('validationError'), (context, name, value, validationError) => validationError || context.question.getFieldErrorMessage(name, value)),
            formulaError: (0, reselect_1.createSelector)((0, selectors_1.property)('result'), (result) => result && result.error),
            touched: (0, reselect_1.createSelector)((0, selectors_1.property)('touched'), (0, selectors_1.property)('validationError'), 
            // FIXME: This is a temporary solution, not sure if this logic is alright.
            (touched, validationError) => touched || !!validationError),
            submitFailed: (0, reselect_1.createSelector)((0, selectors_1.property)('validationError'), (validationError) => !!validationError),
        });
        this.debounceTimeout = null;
        this.debounce = (action, delay) => {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }
            this.debounceTimeout = setTimeout(action, delay);
        };
    }
    componentWillUnmount() {
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
            delete this.debounceTimeout;
        }
    }
    getDefaultChildrenProps(state = this.state, props = this.props) {
        const { disabled, context, contextOptions, questionSlug } = props;
        const childrenProps = {
            meta: this.getMeta(state, props),
            input: this.getInput(state, props),
            'data-testid': `form-field-${questionSlug}`,
        };
        // NOTE: Can either be disabled explicitly,
        //       via context property, or it can be
        //       a direct question property.
        if (disabled ||
            (contextOptions && contextOptions.disabled) ||
            context.question.shouldDisableInput()) {
            childrenProps.disabled = true;
        }
        // NOTE: I don't think that it's good to force this label here
        //       because depending on the context user may want to use
        //       question.title or question.label, so better leave the
        //       decision to them.
        // if (context.question.getLabel()) {
        //   childrenProps.label = context.question.getLabel();
        // }
        return childrenProps;
    }
    dispatchChangeToStore(name, value) {
        const { context, dispatch, onChange } = this.props;
        dispatch(context.setValue(name, value));
        if (onChange) {
            onChange(name, value, {
                context,
                dispatch,
            });
        }
    }
    // eslint-disable-next-line react/sort-comp
    handleOnChange(event) {
        const { name, contextOptions } = this.props;
        const value = (0, getValue_1.default)(event, isReactNative_1.default);
        const delay = contextOptions && contextOptions.debounceEdit;
        const disabled = contextOptions && contextOptions.disabled;
        if (disabled) {
            return;
        }
        if (delay) {
            // Update local state immediately, but dispatch to store with delay.
            // Setting pending flag will prevent updates to state via props.value
            // until props.value is equal to state.value at least once. So one can
            // think about it as component opting-out from controlled mode for
            // a fraction of second.
            this.setState({
                value,
                pending: true,
            });
            this.debounce(() => {
                this.dispatchChangeToStore(name, value);
                this.setState((state) => state.pending
                    ? {
                        pending: false,
                    }
                    : null);
            }, delay);
        }
        else {
            this.setState({
                value,
            });
            this.dispatchChangeToStore(name, value);
        }
    }
    render() {
        const _a = this.props, { name, touched, children, component: Component, context, dispatch, result, value, validationError, contextOptions, disabled, onChange, forwardedRef } = _a, other = __rest(_a, ["name", "touched", "children", "component", "context", "dispatch", "result", "value", "validationError", "contextOptions", "disabled", "onChange", "forwardedRef"]);
        if (typeof children === 'function') {
            return children(Object.assign(Object.assign({ component: Component, forwardedRef }, this.getDefaultChildrenProps()), other));
        }
        if (Component) {
            return (react_1.default.createElement(Component, Object.assign({ ref: forwardedRef }, this.getDefaultChildrenProps(), other)));
        }
        return null;
    }
}
Field.propTypes = {
    name: prop_types_1.default.string,
    value: prop_types_1.default.any, // eslint-disable-line react/forbid-prop-types
    validationError: prop_types_1.default.string,
    touched: prop_types_1.default.bool,
    children: prop_types_1.default.func,
    component: prop_types_1.default.elementType,
    context: prop_types_1.default.instanceOf(SelectorsHub_1.default).isRequired,
    dispatch: prop_types_1.default.func.isRequired,
    result: prop_types_1.default.shape({
        // eslint-disable-next-line react/forbid-prop-types
        value: prop_types_1.default.any,
        // eslint-disable-next-line react/forbid-prop-types
        error: prop_types_1.default.any,
    }),
    disabled: prop_types_1.default.bool,
    contextOptions: prop_types_1.default.shape({
        disabled: prop_types_1.default.bool,
        debounceEdit: prop_types_1.default.number,
    }),
    onChange: prop_types_1.default.func,
    forwardedRef: propTypes_1.PropTypesRef,
};
Field.defaultProps = {
    name: 'value',
    value: null,
    validationError: null,
    touched: false,
    children: null,
    component: null,
    result: null,
    disabled: false,
    contextOptions: null,
    onChange: null,
    forwardedRef: null,
};
exports.default = (0, recompose_1.compose)((0, QuestionnaireContext_1.withContext)({
    forwardRef: true,
}), (0, react_redux_1.connect)(() => {
    const selectFormValue = (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (0, selectors_1.property)('name'), (context, name) => context.createFormValueSelector(name));
    const selectValidationError = (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (0, selectors_1.property)('name'), (context, name) => context.createValidationErrorSelector(name));
    const selectFieldTouched = (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (0, selectors_1.property)('name'), (context, name) => context.createTouchedSelector(name));
    const selectQuestionnaire = (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (context) => context.select.questionnaire());
    const selectOriginalQuestion = (0, reselect_1.createSelector)((0, selectors_1.property)('context.questionId'), selectQuestionnaire, (questionId, questionnaire) => questionnaire && questionnaire.getQuestionById(questionId));
    const selectFormulaResult = (0, reselect_1.createSelector)((0, reselect_1.createSelector)((state, props) => props.context.select.evaluationScope(props.context.scopeKey)(state), selectOriginalQuestion, (evaluationScope, question) => {
        if (question &&
            question.isFormula() &&
            question.hasFormulaToEvaluate()) {
            return evaluationScope.lookupAnswer(question.id);
        }
        return null;
    }), (0, reselect_1.defaultMemoize)(selectors_1.identity, isEqual_1.default));
    return (0, reselect_1.createStructuredSelector)({
        touched: selectFieldTouched,
        questionSlug: (0, reselect_1.createSelector)(selectOriginalQuestion, (question) => question && question.getSlug()),
        value: (0, reselect_1.createSelector)((0, selectors_1.property)('name'), selectFormValue, selectFormulaResult, (name, value, result) => {
            if (name !== 'value') {
                return value;
            }
            if (result && !result.error) {
                return result.value;
            }
            return value;
        }),
        validationError: selectValidationError,
        result: selectFormulaResult,
        contextOptions: (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (context) => context.select.options()),
    });
}, null, null, {
    forwardRef: true,
}))((0, react_1.forwardRef)((props, ref) => (react_1.default.createElement(Field
// eslint-disable-next-line react/jsx-props-no-spreading
, Object.assign({}, props, { forwardedRef: ref })))));
//# sourceMappingURL=Field.js.map